export default "__VITE_ASSET__B4qJ6_1X__"